// src/components/Footer/Footer.jsx
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const CONTACTS = [
  { icon: "✉", labelKey: "footer.email",    href: "mailto:bonecastofficial@gmail.com" },
  { icon: "◎", labelKey: "footer.instagram", href: "https://www.instagram.com/bonecastofficial?igsh=MWJvYWdkc3E2bWE4bg==" },
  { icon: "✕", labelKey: "footer.twitter",  href: "https://x.com/BoneCastOfcl" },
  { icon: "▶", labelKey: "footer.youtube",  href: "https://youtube.com/@bonecastofficial?si=VuQEsJTDlVdT61Wq" },
  { icon: "◈", labelKey: "footer.discord",  href: null },
];

const QUICK_LINKS = [
  { labelKey: "footer.bonechat",    href: "/bonebeat"  },
  { labelKey: "footer.bonebeat",    href: "/bonebeat"  },
  { labelKey: "footer.boneforge",   href: "/boneforge" },
];

const LEGAL_LINKS = [
  { labelKey: "legal.termsLink",   href: "/terms"   },
  { labelKey: "legal.privacyLink", href: "/privacy" },
];

function ColTitle({ children }) {
  return (
    <div style={{
      fontFamily: "'Courier Prime', monospace", fontSize: 9,
      letterSpacing: "0.32em", color: "var(--bone-text-accent)",
      textTransform: "uppercase", marginBottom: 18,
      paddingBottom: 10, borderBottom: "1px solid rgba(212,168,83,0.4)",
    }}>
      {children}
    </div>
  );
}

function FLink({ href, icon, label }) {
  const [hov, setHov] = useState(false);
  const Tag = href ? "a" : "span";
  const isExternal = href?.startsWith("http");
  return (
    <Tag
      href={href || undefined}
      target={isExternal ? "_blank" : undefined}
      rel={isExternal ? "noopener noreferrer" : undefined}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        display: "flex", alignItems: "center", gap: 10,
        textDecoration: "none", cursor: href ? "pointer" : "default",
        color: hov && href ? "var(--bone-text-accent)" : "var(--bone-text-secondary)",
        fontFamily: "'Courier Prime', monospace", fontSize: 11,
        letterSpacing: "0.07em", transition: "color 0.2s ease", lineHeight: 1.7,
      }}
    >
      <span style={{ fontSize: 10, minWidth: 12, textAlign: "center", opacity: 0.7 }}>{icon}</span>
      {label}
    </Tag>
  );
}

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer style={{ borderTop: "1px solid rgba(212,168,83,0.4)", background: "#0a0804", padding: "52px clamp(24px,8vw,120px) 32px" }}>

      {/* 3 sütun */}
      <div style={{ maxWidth: 1200, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "40px 60px", marginBottom: 48 }}>

        {/* Sütun 1 — İletişim */}
        <div>
          <ColTitle>✦ {t('footer.contact')} ✦</ColTitle>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {CONTACTS.map((c, i) => (
              <FLink key={i} href={c.href} icon={c.icon} label={t(c.labelKey)} />
            ))}
          </div>
        </div>

        {/* Sütun 2 — Hızlı Erişim */}
        <div>
          <ColTitle>✦ {t('footer.quickAccess')} ✦</ColTitle>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {QUICK_LINKS.map((l) => (
              <FLink key={l.href + l.labelKey} href={l.href} icon="→" label={t(l.labelKey)} />
            ))}
          </div>
        </div>

        {/* Sütun 3 — Hukuki */}
        <div>
          <ColTitle>✦ {t('footer.legal')} ✦</ColTitle>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {LEGAL_LINKS.map((l) => (
              <FLink key={l.href} href={l.href} icon="§" label={t(l.labelKey)} />
            ))}
          </div>
          <div style={{ marginTop: 28, paddingTop: 20, borderTop: "1px solid rgba(212,168,83,0.4)" }}>
            <span style={{ fontFamily: "'Playfair Display', serif", fontStyle: "italic", fontSize: 20, fontWeight: 700, color: "var(--bone-text-primary)", letterSpacing: "0.04em" }}>
              BoneCast
            </span>
          </div>
        </div>
      </div>

      {/* Alt şerit */}
      <div style={{ maxWidth: 1200, margin: "0 auto", paddingTop: 20, borderTop: "1px solid rgba(212,168,83,0.4)", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
        <span style={{ fontFamily: "'Courier Prime', monospace", fontSize: 9, letterSpacing: "0.22em", color: "var(--bone-text-secondary)", textTransform: "uppercase" }}>
          {t('footer.copyright')}
        </span>
        <span style={{ fontFamily: "'Courier Prime', monospace", fontSize: 9, letterSpacing: "0.18em", color: "var(--bone-text-muted)", textTransform: "uppercase" }}>
          v1.0.4
        </span>
      </div>
    </footer>
  );
}
